import { render, staticRenderFns } from "./analysisXk.vue?vue&type=template&id=07e7473c&scoped=true"
import script from "./analysisXk.vue?vue&type=script&lang=js"
export * from "./analysisXk.vue?vue&type=script&lang=js"
import style0 from "./analysisXk.vue?vue&type=style&index=0&id=07e7473c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e7473c",
  null
  
)

export default component.exports